<div class="col-12 flex">
    @if (item.isSystem) {
    <div class="col-1 flex align-items-center justify-content-center">
        <i class="fa-solid fa-bell text-400" style="font-size: 2rem"></i>
    </div>
    <div class="col-11">
        <div class="flex align-items-center gap-2 p-2">
            <app-avatar [user]="item.creationUser"></app-avatar>
            <span>{{ item.content }} le {{ item.messageDatetime.toDate() | date:'dd/MM/yyyy
                \'à\' HH\'h\'mm' }}</span>
        </div>
    </div>
    } @else if (!!item.author || item.isEmail) {
    <div class="col-1 flex align-items-center justify-content-center">
        <!-- Avatar de l'auteur, ou enveloppe pour un email sans auteur résolu -->
        @if (!!item.author) {
        <app-avatar [user]="item.author.user" [label]="item.author.avatarLabel" size="large"></app-avatar>
        } @else {
        <p-avatar icon="pi pi-envelope" size="large" shape="circle"></p-avatar>
        }
    </div>
    <div class="col-11">
        <!-- Contenu du message -->
        <div class="border-1 border-200 border-round-lg"
            [ngClass]="{ 'border-primary-200': item.creationUser.id === appService.user!.id }">
            <!-- Header -->
            <div class="p-3 surface-100 border-bottom-1 border-200"
                [ngClass]="{ 'border-primary-200': item.creationUser.id === appService.user!.id, 'bg-primary-50': item.creationUser.id === appService.user!.id }">
                <strong>{{ item.author ? item.author.fullName : item.emailInAddress }}</strong> le {{ item.messageDatetime.toDate() |
                date:'dd/MM/yyyy
                \'à\' HH\'h\'mm' }}
            </div>

            <!-- Contenu -->
            <div class="p-3" [innerHTML]="getHighlightedContent(item)"></div>

            <!-- Pièces jointes -->
            @if (item.attachments && item.attachments.length > 0) {
            <div class="px-3 pb-3">
                <div class="flex flex-wrap gap-2">
                    @for (attachment of item.attachments; track attachment.id) {
                    <div class="surface-100 border-1 border-200 border-round-3xl p-2 cursor-pointer hover:bg-primary-50 transition-colors transition-duration-200"
                        (click)="onAttachmentClick(attachment)">
                        <div class="flex align-items-center gap-2">
                            <i [class]="attachment.mimeTypeIcon + ' text-600'"></i>
                            <span class="text-sm" [title]="attachment.fileName">
                                {{ getTruncatedFileName(attachment.fileName) }}
                            </span>
                        </div>
                    </div>
                    }
                </div>
            </div>
            }
        </div>
    </div>
    } @else {
    <!-- Fallback général : type de message non géré, rendu visible pour qu'on en soit informé -->
    <div class="col-1 flex align-items-center justify-content-center">
        <p-avatar icon="pi pi-times" size="large" shape="circle"
            [style]="{ 'background-color': 'var(--red-500)', color: '#ffffff' }"></p-avatar>
    </div>
    <div class="col-11 flex align-items-center">
        <span class="text-500 font-italic">Un message ne peut être affiché</span>
    </div>
    }
</div>